var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "", id: "profile-account" } },
    [
      _c("profile-child-account", {
        staticClass: "mt-0",
        attrs: {
          loadUpdateAccount: _vm.loadUpdateAccount,
          loadUpdateNotifications: _vm.loadUpdateNotifications,
          loadUpdateImage: _vm.loadUpdateImage
        },
        on: {
          "display-profile-update-modal": _vm.displayModal,
          "display-snackbar": _vm.displaySnackBar,
          updateImage: _vm.handleUpdateImage,
          updateNotifications: _vm.handleUpdateNotifications
        }
      }),
      _vm._v(" "),
      _c("profile-child-notification", {
        staticClass: "mt-5",
        attrs: { loadUpdateAccount: _vm.loadUpdateAccount },
        on: {
          "display-profile-update-modal": _vm.displayModal,
          "display-snackbar": _vm.displaySnackBar
        }
      }),
      _vm._v(" "),
      _c("profile-update-modal", {
        attrs: {
          visible: _vm.modal.display,
          titleModal: _vm.modal.title,
          textModal: _vm.modal.msg
        },
        on: {
          "update:visible": function($event) {
            _vm.$set(_vm.modal, "display", $event)
          },
          save: function($event) {
            _vm.modal.save(_vm.modal.params)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            bottom: "",
            right: "",
            color: _vm.snackbar.color,
            timeout: _vm.snackbar.timeout
          },
          model: {
            value: _vm.snackbar.open,
            callback: function($$v) {
              _vm.$set(_vm.snackbar, "open", $$v)
            },
            expression: "snackbar.open"
          }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.snackbar.text) + "\n      "),
          _c(
            "v-btn",
            {
              attrs: {
                color: _vm.snackbar.color === "error" ? "white" : "secondary",
                flat: ""
              },
              on: {
                click: function($event) {
                  _vm.snackbar.open = false
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t(_vm.lblSetting.btnClose)) +
                  "\n      "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbdcf280", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbdcf280","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/profile-child/template.html
// module id = null
// module chunks = 